import { FC, ReactElement } from 'react';

import { Card, Icon } from '../../../../../components';
import { getRoleForTranslation } from '../../../../../helpers/role';
import trans from '../../../../../helpers/trans';
import { UserRole } from '../../../../../types';

import './DevelopmentPlanEvaluationNullState.scss';

interface DevelopmentPlanEvaluationNullStateProps {
    userRoles?: UserRole[];
    className?: string;
}

const DevelopmentPlanEvaluationNullState: FC<DevelopmentPlanEvaluationNullStateProps> = ({
    userRoles,
    className = '',
}): ReactElement => (
    <Card className={`development-plan-evaluation-null-state ${className}`}>
        <div className="development-plan-evaluation-null-state__icon-wrapper">
            <Icon name="development" className="development-plan-evaluation-null-state__icon" />
        </div>

        <h1 className="development-plan-evaluation-null-state__title">
            {trans('containers.developmentPlanEvaluation.nullState.title')}
        </h1>
        <p className="development-plan-evaluation-null-state__description">
            {trans(`containers.developmentPlanEvaluation.nullState.description.${getRoleForTranslation(userRoles)}`)}
        </p>
    </Card>
);

export default DevelopmentPlanEvaluationNullState;
